<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>{{ note.note_ref }}</h5>
      <br />
      <p>
        Date de création :
        <b v-if="note.created_at">{{ getDate(note.created_at) }}</b> | |
        <b>{{ note.user_name }}</b> |
        <span v-if="note.statut == 0" class="badge text-bg-warning fs-13">
          Brouillon
        </span>
        <span v-else class="badge text-bg-success fs-13"> Enregistré </span>
      </p>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="note.statut == 0"
  >
    <div class="card-header">
      <h5>Scan référence bon</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form v-on:submit.prevent="scanNote">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label>Référence bon :</label>
                <input
                  placeholder="Référence"
                  type="text"
                  id="scanFocus"
                  v-model="scanRef"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-4">
              <button class="btn btn-success me-3 mb-3 mt-3" type="submit">
                <i class="ph ph-scan"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="note.statut == 0"
  >
    <div class="card-header">
      <h5>Bons disponibles</h5>
    </div>

    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          @click="addSelectedNotes"
          :disabled="loadAdd"
        >
          <template v-if="loadAdd">
            <div class="spinner-border text-white" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </template>
          Ajouter
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          @input="getAvailable()"
          v-model="available.searchTerm"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table
        :columns="columns"
        :rows="rowsAvailable"
        :select-options="{
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'bons sélectionnés',
        }"
        @select-all="onSelectAllAvailable"
        @selected-rows-change="onSelectionAvailable"
      >
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'type'">
            {{ typeLabel(props.row.type) }}
          </template>
          <template v-else-if="props.column.field === 'created_at'">
            {{ getDate(props.row.created_at) }}
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="available"
        :offset="9"
        @paginate="getAvailable"
      />
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>Bons ajoutés</h5>
    </div>

    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center" v-if="note.statut == 0">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          @click="removeSelectedNotes"
          :disabled="loadRemove"
        >
          <template v-if="loadRemove">
            <div class="spinner-border text-white" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </template>
          Supprimer
          <i class="flaticon-delete position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          @input="getAdded()"
          v-model="added.searchTerm"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table
        :columns="columns"
        :rows="rowsAdded"
        :select-options="{
          enabled: note.statut == 0,
          selectOnCheckboxOnly: true,
          clearSelectionText: 'Annuler',
          selectionText: 'bons sélectionnés',
        }"
        @select-all="onSelectAllAdded"
        @selected-rows-change="onSelectionAdded"
      >
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'type'">
            {{ typeLabel(props.row.type) }}
          </template>
          <template v-else-if="props.column.field === 'created_at'">
            {{ getDate(props.row.created_at) }}
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="added"
        :offset="9"
        @paginate="getAdded"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, ref, onMounted } from "vue";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useRoute } from "vue-router";

export default {
  name: "PointageDetails",

  setup: () => {
    const route = useRoute();
    const { showToast } = useAppToast();

    const noteRef = Array.isArray(route.params.ref)
      ? route.params.ref[0]
      : String(route.params.ref);

    const note = ref<any>({});
    const rowsAvailable = ref<any[]>([]);
    const rowsAdded = ref<any[]>([]);
    const selectedAvailable = ref<any[]>([]);
    const selectedAdded = ref<any[]>([]);
    const scanRef = ref("");
    const loadAdd = ref(false);
    const loadRemove = ref(false);

    const columns = [
      { label: "Référence", field: "note_ref" },
      { label: "Destinataire", field: "for_name" },
      { label: "Pour", field: "note_for" },
      { label: "Créé par", field: "by_name" },
      { label: "Transport", field: "transport_name" },
      { label: "Colis", field: "total_parcel" },
      { label: "Type", field: "type" },
      { label: "Date", field: "created_at" },
    ];

    const available = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const added = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    function getDate(value: string) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function typeLabel(type: number) {
      if (type === 1) return "Retour Zone";
      if (type === 2) return "Retour Client";
      if (type === 3) return "Retour Agence";
      if (type === 4) return "Retour Endomagé";
      return "";
    }

    async function getNote() {
      const res = await api.get(`/api/auth/showNotePoint`, {
        params: { ref: noteRef },
      });
      note.value = res.data.note || {};
    }

    async function getAvailable(page = 1) {
      available.current_page = page;
      const res = await api.get(
        `/api/auth/notesToAdd?searchTerm=${available.searchTerm}&page=${available.current_page}&per_page=${available.per_page}`,
        { params: { ref: noteRef } }
      );
      if (res.data.msg === "success") {
        rowsAvailable.value = res.data.users.data;
        Object.assign(available, res.data.users);
      } else {
        rowsAvailable.value = [];
      }
    }

    async function getAdded(page = 1) {
      added.current_page = page;
      const res = await api.get(
        `/api/auth/notesInAdd?searchTerm=${added.searchTerm}&page=${added.current_page}&per_page=${added.per_page}`,
        { params: { ref: noteRef } }
      );
      if (res.data.msg === "success") {
        rowsAdded.value = res.data.users.data;
        Object.assign(added, res.data.users);
      } else {
        rowsAdded.value = [];
      }
    }

    function onSelectAllAvailable(params: any) {
      selectedAvailable.value = params.selectedRows;
    }
    function onSelectionAvailable(params: any) {
      selectedAvailable.value = params.selectedRows;
    }
    function onSelectAllAdded(params: any) {
      selectedAdded.value = params.selectedRows;
    }
    function onSelectionAdded(params: any) {
      selectedAdded.value = params.selectedRows;
    }

    async function refreshAll() {
      await Promise.all([getNote(), getAvailable(), getAdded()]);
    }

    async function addSelectedNotes() {
      if (!selectedAvailable.value.length) {
        showToast("Veuillez sélectionner des bons", "error");
        return;
      }
      try {
        loadAdd.value = true;
        const data = new FormData();
        data.append("bons", JSON.stringify(selectedAvailable.value));
        data.append("note_ref", noteRef);

        const res = await api.post(`/api/auth/AddNoteToPoint`, data);
        if (res.data.message === "success") {
          showToast("Bons ajoutés avec succès", "success");
          await refreshAll();
        } else {
          showToast("Erreur lors de l'ajout", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      } finally {
        loadAdd.value = false;
      }
    }

    async function removeSelectedNotes() {
      if (!selectedAdded.value.length) {
        showToast("Veuillez sélectionner des bons", "error");
        return;
      }
      try {
        loadRemove.value = true;
        const data = new FormData();
        data.append("bons", JSON.stringify(selectedAdded.value));
        data.append("note_ref", noteRef);

        const res = await api.post(`/api/auth/removeNoteFromPoint`, data);
        if (res.data.message === "success") {
          showToast("Bons supprimés avec succès", "success");
          await refreshAll();
        } else {
          showToast("Erreur lors de la suppression", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      } finally {
        loadRemove.value = false;
      }
    }

    async function scanNote() {
      if (!scanRef.value) return;
      try {
        const data = new FormData();
        data.append("ref", noteRef);
        data.append("note_ref", scanRef.value);

        const res = await api.post(`/api/auth/scanNoteToPoint`, data);
        scanRef.value = "";

        if (res.data.success) {
          const audio = new Audio("/sound.mp3");
          audio.play();
          showToast("Bon ajouté avec succès", "success");
          document.getElementById("scanFocus")?.focus();
          await refreshAll();
        } else {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast(res.data.message || "Impossible d'ajouter ce bon", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }

    onMounted(async () => {
      await refreshAll();
    });

    return {
      note,
      columns,
      rowsAvailable,
      rowsAdded,
      available,
      added,
      scanRef,
      loadAdd,
      loadRemove,

      getDate,
      typeLabel,
      getAvailable,
      getAdded,
      onSelectAllAvailable,
      onSelectionAvailable,
      onSelectAllAdded,
      onSelectionAdded,
      addSelectedNotes,
      removeSelectedNotes,
      scanNote,
    };
  },
};
</script>
